import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { ModelData, TrimData } from '@/types'

export const useModelComparisonStore = defineStore('modelComparison', () => {
  const selectedYear = ref<number | null>(null)
  const selectedMake = ref<string | null>(null)
  const selectedModel = ref<string | null>(null)
  const comparisonModel = ref<ModelData | null>(null)
  const comparisonTrim = ref<TrimData | null>(null)

  const setComparisonSelection = (
    year: number | null,
    make: string | null,
    model: string | null,
  ) => {
    selectedYear.value = year
    selectedMake.value = make
    selectedModel.value = model
  }

  const setComparisonData = (
    model: ModelData | null,
    trim: TrimData | null,
  ) => {
    comparisonModel.value = model
    comparisonTrim.value = trim
  }

  const clearComparison = () => {
    selectedYear.value = null
    selectedMake.value = null
    selectedModel.value = null
    comparisonModel.value = null
    comparisonTrim.value = null
  }

  return {
    selectedYear,
    selectedMake,
    selectedModel,
    comparisonModel,
    comparisonTrim,
    setComparisonSelection,
    setComparisonData,
    clearComparison,
  }
})
